var foodLoopAnimationData = {
  v: '5.1.1',
  fr: 30,
  ip: 0,
  op: 242,
  w: 1000,
  h: 900,
  nm: 'Export 2',
  ddd: 0,
  assets: [{
    id: 'comp_0',
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Salad Leaf Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [967.123, 540, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [960, 540, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [145, 145, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[25.84, 25.569], [-25.84, -25.569]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [831.171, 333.628],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[17.672, -7.139], [-17.672, 7.139]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [1143.654, 347.818],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 2',
        np: 2,
        cix: 2,
        ix: 2,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[33.273, -36.387], [-33.274, 36.387]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [1024.914, 365.435],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 3',
        np: 2,
        cix: 2,
        ix: 3,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[20.995, -26.2], [-20.996, 26.2]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [882.513, 449.723],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 4',
        np: 2,
        cix: 2,
        ix: 4,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[13.477, -13.477], [-13.477, 13.477]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [763.91, 407.876],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 5',
        np: 2,
        cix: 2,
        ix: 5,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [5.957, 12.07], [10.278, 8.333], [14.023, 2.767], [15.246, -7.595], [11.789, -12.895], [8.272, -13.491], [10.333, -12.812]],
              o: [[-19.332, -41.688], [-5.52, -11.181], [-9.156, -7.422], [-17.972, -3.548], [-14.893, 7.42], [-12.021, 13.149], [-13.081, 21.332], [0, 0]],
              v: [[92.537, 61.089], [106.176, -8.67], [65.495, -24.88], [40.342, -60.706], [-6.751, -31.945], [-60.354, -18.039], [-72.848, 36.88], [-112.133, 64.255]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [867.348, 431.679],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 6',
        np: 2,
        cix: 2,
        ix: 6,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [14.367, 14.133], [13.975, -0.149], [-0.05, -8.773], [-10.751, -10.576], [-7.875, -2.51]],
              o: [[4.699, -18.205], [-10.751, -10.577], [-8.773, 0.094], [0.08, 13.975], [6.295, 6.193], [0, 0]],
              v: [[32.156, 34.124], [17.637, -18.354], [-21.115, -33.975], [-36.806, -18.025], [-20.553, 20.467], [1.036, 33.517]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [814.082, 314.301],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 7',
        np: 2,
        cix: 2,
        ix: 7,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [-18.59, 19.858], [-19.951, -0.27], [-0.776, -9.748], [14.712, -15.715], [14.919, -2.741]],
              o: [[-7.348, -24.29], [14.711, -15.714], [9.779, 0.133], [1.584, 19.89], [-11.164, 11.927], [0, 0]],
              v: [[-42.077, 47.203], [-25.411, -24.376], [29.239, -47.621], [47.841, -30.207], [28.247, 25.856], [-12.039, 47.891]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [1047.144, 339.425],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 8',
        np: 2,
        cix: 2,
        ix: 8,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, -13.215], [13.216, 0], [0, 13.216], [-13.216, 0]],
              o: [[0, 13.216], [-13.216, 0], [0, -13.215], [13.216, 0]],
              v: [[23.929, 0], [0, 23.929], [-23.929, 0], [0, -23.929]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [930.866, 301.215],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 9',
        np: 2,
        cix: 2,
        ix: 9,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, -16.549], [16.549, 0], [0, 16.549], [-16.55, 0]],
              o: [[0, 16.549], [-16.55, 0], [0, -16.549], [16.549, 0]],
              v: [[29.965, 0], [0, 29.965], [-29.965, 0], [0, -29.965]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [1118.236, 426.491],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 10',
        np: 2,
        cix: 2,
        ix: 10,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            n: ['0p667_1_0p333_0'],
            t: 12,
            s: [100],
            e: [0]
          }, {
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            n: ['0p667_1_0p333_0'],
            t: 27,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            n: ['0p667_1_0p333_0'],
            t: 85,
            s: [0],
            e: [100]
          }, {
            t: 100
          }],
          ix: 1
        },
        e: {
          a: 0,
          k: 100,
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 11,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }],
      ip: 8,
      op: 113,
      st: -2204,
      bm: 0
    }, {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Pizza Topping Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [968.405, 540, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [960, 540, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [145, 145, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [47.724, 38.554]],
              o: [[0, 0], [0, 0]],
              v: [[15.505, 48.512], [-23.862, -48.512]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [1033.518, 502.835],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [35.48, -31.221]],
              o: [[0, 0], [0, 0]],
              v: [[39.396, -1.662], [-39.396, 15.61]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [923.765, 571.913],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 2',
        np: 2,
        cix: 2,
        ix: 2,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, -16.824], [16.823, 0], [0, 16.823], [-16.824, 0]],
              o: [[0, 16.823], [-16.824, 0], [0, -16.824], [16.823, 0]],
              v: [[30.462, 0], [0, 30.462], [-30.462, 0], [0, -30.462]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [979.231, 669.912],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 3',
        np: 2,
        cix: 2,
        ix: 3,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, -20.349], [20.349, 0], [0, 20.349], [-20.349, 0]],
              o: [[0, 20.349], [-20.349, 0], [0, -20.349], [20.349, 0]],
              v: [[36.846, 0], [0, 36.846], [-36.846, 0], [0, -36.846]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647058824, 0.549019607843, 0.560784313725, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 2,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [897.252, 474.295],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 4',
        np: 2,
        cix: 2,
        ix: 4,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 192,
            s: [100],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            n: ['0p34_1_0p167_0'],
            t: 210,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            n: ['0p34_1_0p167_0'],
            t: 269,
            s: [0],
            e: [100]
          }, {
            t: 284
          }],
          ix: 1
        },
        e: {
          a: 0,
          k: 100,
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 5,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }],
      ip: 190,
      op: 326,
      st: -2734,
      bm: 0
    }, {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'master_Food Solid Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [952.236, 540, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [960, 540, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [145, 145, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [-5.76, -6.837], [-8.758, 5.727], [-14.107, 2.601], [-19.377, -2.227], [-15.302, -0.244], [-24.13, 1.446], [-32.384, -1.197], [-15.486, -3.887], [-15.558, -5.214], [-13.749, -6.214], [-8.078, -3.609], [0, 0], [6.077, 0], [0, 0], [0, -8.109], [0, 0], [0, 0], [-116.519, 0], [-13.486, 103.517], [-15.855, 0], [0, 0], [0, 0], [0, 19.52], [0, 0], [13.998, 12.466], [0, 0], [7.866, 9.747], [104.98, 0], [35.112, -56.864], [-17.211, -14.674], [-14.754, 0], [-30.785, 0], [-30.789, 0], [-30.79, 0], [-30.791, 0], [-30.79, 0], [-30.794, 0], [-7.456, 3.704], [0, -16.208], [0, 0], [12.058, 0], [0, 0], [0, -12.059], [-12.058, 0], [0, 0], [0, -12.058], [0, 0], [11.709, -0.111], [23.751, -9.744], [8.345, 4.056], [123.615, 1.564], [0, -12.153], [0, 0], [-13.35, -0.004], [0, 0], [7.106, -15.342], [117.788, 0], [34.441, 44.886], [10.797, 0], [0, 0], [0, 13.511], [0, 0], [-22.399, 0], [0, 0], [-5.818, 3.292], [-194.702, -94.69], [9.879, -19.248], [0, 0], [14.648, 27.574], [0, 0], [-21.472, 8.454], [-170.251, -103.582], [-7.018, 0], [0, 0], [0, -15.287], [0, 0], [15.286, 0], [0, 0], [15.013, 21.157], [1.849, 1.346], [12.252, 6.255], [13.127, 4.262], [13.69, 2.152], [13.925, 0], [13.337, -2.095], [12.899, -4.188], [12.125, -6.19], [11.824, -5.979], [2.764, -1.002], [0, -97.307], [-22.812, 0], [0, 27.414], [-124.421, 0.348], [0, -124.823], [0, 0], [23.896, 0], [0, 0], [44.139, 0.599], [-1.806, 36.013], [-15.383, -0.781]],
              o: [[0, 0], [8.94, 0], [7.569, 8.983], [12.854, -8.407], [17.096, -3.152], [15.84, 1.819], [27.541, 0.439], [34.018, -2.041], [33.916, 1.254], [18.802, 4.719], [12.966, 4.345], [12.561, 5.675], [12.422, 5.549], [0, 6.079], [0, 0], [-8.109, 0], [0, 0], [0, 0], [0, 116.519], [107.193, 0], [2.047, -15.722], [0, 0], [0, 0], [19.516, 0.335], [0, 0], [0, 0], [-15.717, -13.998], [-12.525, 0], [-35.46, -43.94], [-98.814, 0], [-11.883, 19.244], [12.094, 10.311], [30.786, 0], [30.789, 0], [30.79, 0], [30.791, 0], [30.79, 0], [30.794, 0], [14.893, 0], [14.513, -7.213], [0, 0], [0, 12.058], [0, 0], [-12.058, 0], [0, 12.058], [0, 0], [12.058, 0], [0, 0], [0, 11.71], [-144.781, 1.381], [-8.584, 3.522], [-19.92, -9.685], [-12.153, -0.154], [0, 0], [0, 13.351], [0, 0], [16.907, 0.005], [-24.304, 52.481], [-106.41, 0], [-6.573, -8.565], [0, 0], [-13.511, 0], [0, 0], [0, -22.4], [0, 0], [6.686, 0], [39.67, -22.453], [19.457, 9.463], [0, 0], [-14.257, 27.778], [0, 0], [-10.826, -20.38], [78.665, -30.972], [5.995, 3.648], [0, 0], [15.286, 0], [0, 0], [0, 15.287], [0, 0], [-25.943, 0], [-1.361, -1.919], [-11.041, -8.035], [-12.125, -6.19], [-12.899, -4.188], [-13.337, -2.095], [-13.925, 0], [-13.691, 2.152], [-13.127, 4.262], [-11.231, 5.734], [-2.624, 1.326], [-85.448, 31.007], [0, 27.11], [22.812, 0], [0, -124.597], [124.822, -0.349], [0, 0], [0, 23.896], [0, 0], [0, 0], [-14.785, -0.201], [0.261, -5.21], [14.605, 0.741]],
              v: [[-272.114, -26.554], [-235.798, -26.554], [-212.756, -15.588], [-179.395, -15.225], [-147.087, -46.341], [-108.195, -20.828], [-53.872, -41.149], [-3.384, -11.554], [63.295, -76.036], [103.493, -19.267], [146.631, -46.193], [166.871, -15.541], [199.818, -21.937], [213.047, 12.279], [202.042, 23.284], [-200.848, 23.284], [-215.531, 37.968], [-215.531, 53.022], [-215.523, 53.022], [-4.546, 263.999], [204.654, 80.541], [235.885, 53.022], [261.812, 53.022], [274.739, 53.243], [310.255, 18.33], [309.566, -100.147], [297.842, -142.587], [247.115, -156.38], [214.756, -171.645], [-15.322, -246.781], [-249.45, -161.231], [-240.568, -102.055], [-200.072, -86.7], [-138.501, -102.037], [-76.923, -86.7], [-15.343, -102.037], [46.239, -86.7], [107.819, -102.037], [169.408, -86.7], [199.446, -93.992], [230.995, -74.441], [230.995, -67.327], [209.162, -45.494], [-239.807, -45.494], [-261.641, -23.66], [-239.807, -1.827], [188.473, -1.827], [210.306, 20.006], [210.306, 28.547], [189.156, 49.874], [-19.006, 76.488], [-45.628, 75.775], [-239.537, 49.912], [-261.64, 71.744], [-261.641, 99.577], [-237.47, 123.755], [203.893, 123.875], [225.244, 156.734], [-15.322, 248.487], [-246.818, 171.551], [-274.468, 158.086], [-285.792, 158.086], [-310.256, 133.622], [-310.256, -67.459], [-269.698, -108.017], [-249.061, -108.017], [-229.995, -113.047], [178.283, -126.694], [195.628, -74.352], [32.996, 242.5], [-35.516, 242.983], [-235.634, -133.728], [-215.663, -187.819], [216.955, -166.975], [236.871, -161.443], [269.174, -161.443], [296.853, -133.764], [296.853, -99.07], [269.174, -71.39], [254.526, -71.39], [188.703, -104.494], [183.933, -109.444], [141.117, -118.173], [108.923, -147.721], [65.513, -142.721], [25.744, -160.825], [-14.024, -142.721], [-57.435, -147.721], [-89.629, -118.173], [-133.069, -107.48], [-141.115, -103.886], [-267.73, 84.42], [-226.426, 125.724], [-185.121, 84.42], [24.901, -117.827], [251.855, 109.31], [251.855, 117.71], [208.587, 160.978], [-237.181, 161.323], [-275.803, 160.633], [-282.573, -18.072], [-253.522, -24.194]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647069693, 0.549019634724, 0.560784339905, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 1,
          ml: 4,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [966.147, 540.147],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            n: ['0p34_1_0p167_0'],
            t: -1,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 29,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 89,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 119,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 179,
            s: [0],
            e: [12]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 209,
            s: [12],
            e: [12]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 269,
            s: [12],
            e: [10]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p833_1_0p66_0'],
            t: 299,
            s: [10],
            e: [10]
          }, {
            i: {
              x: [0.714],
              y: [1]
            },
            o: {
              x: [0.163],
              y: [0]
            },
            n: ['0p714_1_0p163_0'],
            t: 359,
            s: [10],
            e: [21]
          }, {
            t: 377
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.663],
              y: [0.934]
            },
            o: {
              x: [0.331],
              y: [0]
            },
            n: ['0p663_0p934_0p331_0'],
            t: -1,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.362],
              y: [1]
            },
            o: {
              x: [0.164],
              y: [0.115]
            },
            n: ['0p362_1_0p164_0p115'],
            t: 0,
            s: [0],
            e: [8]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 29,
            s: [8],
            e: [8]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 89,
            s: [8],
            e: [22.5]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 119,
            s: [22.5],
            e: [22.5]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 179,
            s: [22.5],
            e: [20]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 209,
            s: [20],
            e: [20]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p833_1_0p66_0'],
            t: 269,
            s: [20],
            e: [22]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            n: ['0p833_1_0p167_0'],
            t: 299,
            s: [22],
            e: [22]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            n: ['0p833_1_0p167_0'],
            t: 359,
            s: [22],
            e: [22.2]
          }, {
            t: 377
          }],
          ix: 2
        },
        o: {
          a: 1,
          k: [{
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            n: ['0p34_1_0p167_0'],
            t: -1,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 29,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 89,
            s: [0],
            e: [74]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 119,
            s: [74],
            e: [74]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 179,
            s: [74],
            e: [175]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 209,
            s: [175],
            e: [175]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 269,
            s: [175],
            e: [251]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p833_1_0p66_0'],
            t: 299,
            s: [251],
            e: [251]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            n: ['0p833_1_0p167_0'],
            t: 359,
            s: [251],
            e: [280]
          }, {
            t: 377
          }],
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }],
      ip: -1,
      op: 389,
      st: 28,
      bm: 0
    }, {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: 'master_Food Dashed Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [952.236, 540, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [960, 540, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [145, 145, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [-5.76, -6.837], [-8.758, 5.727], [-14.107, 2.601], [-19.377, -2.227], [-15.302, -0.244], [-24.13, 1.446], [-32.384, -1.197], [-15.486, -3.887], [-15.558, -5.214], [-13.749, -6.214], [-8.078, -3.609], [0, 0], [6.077, 0], [0, 0], [0, -8.109], [0, 0], [0, 0], [-116.519, 0], [-13.486, 103.517], [-15.855, 0], [0, 0], [0, 0], [0, 19.52], [0.034, 51.86], [6.572, 18.186], [0, 0], [7.866, 9.747], [104.98, 0], [35.112, -56.864], [-17.211, -14.674], [-14.754, 0], [-30.785, 0], [-30.789, 0], [-30.79, 0], [-30.791, 0], [-30.79, 0], [-30.794, 0], [-7.456, 3.704], [0, -16.208], [0, 0], [12.058, 0], [0, 0], [0, -12.059], [-12.058, 0], [0, 0], [0, -12.058], [0, 0], [11.709, -0.111], [23.751, -9.744], [8.345, 4.056], [123.615, 1.564], [0, -12.153], [0, 0], [-13.35, -0.004], [0, 0], [7.106, -15.342], [117.788, 0], [34.441, 44.886], [10.797, 0], [0, 0], [0, 13.511], [0, 0], [-22.399, 0], [0, 0], [-5.818, 3.292], [-194.702, -94.69], [9.879, -19.248], [0, 0], [14.648, 27.574], [0, 0], [-21.472, 8.454], [-170.251, -103.582], [-7.018, 0], [0, 0], [0, -15.287], [0, 0], [15.286, 0], [0, 0], [15.013, 21.157], [1.849, 1.346], [12.252, 6.255], [13.127, 4.262], [13.69, 2.152], [13.925, 0], [13.337, -2.095], [12.899, -4.188], [12.125, -6.19], [11.824, -5.979], [2.764, -1.002], [0, -97.307], [-22.812, 0], [0, 27.414], [-124.421, 0.348], [0, -124.823], [0, 0], [23.896, 0], [0, 0]],
              o: [[0, 0], [8.94, 0], [7.569, 8.983], [12.854, -8.407], [17.096, -3.152], [15.84, 1.819], [27.541, 0.439], [34.018, -2.041], [33.916, 1.254], [18.802, 4.719], [12.966, 4.345], [12.561, 5.675], [12.422, 5.549], [0, 6.079], [0, 0], [-8.109, 0], [0, 0], [0, 0], [0, 116.519], [107.193, 0], [2.047, -15.722], [0, 0], [0, 0], [19.516, 0.335], [0, 0], [-0.017, -25.779], [-7.153, -19.794], [-12.525, 0], [-35.46, -43.94], [-98.814, 0], [-11.883, 19.244], [12.094, 10.311], [30.786, 0], [30.789, 0], [30.79, 0], [30.791, 0], [30.79, 0], [30.794, 0], [14.893, 0], [14.513, -7.213], [0, 0], [0, 12.058], [0, 0], [-12.058, 0], [0, 12.058], [0, 0], [12.058, 0], [0, 0], [0, 11.71], [-144.781, 1.381], [-8.584, 3.522], [-19.92, -9.685], [-12.153, -0.154], [0, 0], [0, 13.351], [0, 0], [16.907, 0.005], [-24.304, 52.481], [-106.41, 0], [-6.573, -8.565], [0, 0], [-13.511, 0], [0, 0], [0, -22.4], [0, 0], [6.686, 0], [39.67, -22.453], [19.457, 9.463], [0, 0], [-14.257, 27.778], [0, 0], [-10.826, -20.38], [78.665, -30.972], [5.995, 3.648], [0, 0], [15.286, 0], [0, 0], [0, 15.287], [0, 0], [-25.943, 0], [-1.361, -1.919], [-11.041, -8.035], [-12.125, -6.19], [-12.899, -4.188], [-13.337, -2.095], [-13.925, 0], [-13.691, 2.152], [-13.127, 4.262], [-11.231, 5.734], [-2.624, 1.326], [-85.448, 31.007], [0, 27.11], [22.812, 0], [0, -124.597], [124.822, -0.349], [0, 0], [0, 23.896], [0, 0], [0, 0]],
              v: [[-272.114, -26.554], [-235.798, -26.554], [-212.756, -15.588], [-179.395, -15.225], [-147.087, -46.341], [-108.195, -20.828], [-53.872, -41.149], [-3.384, -11.554], [63.295, -76.036], [103.493, -19.267], [146.631, -46.193], [166.871, -15.541], [199.818, -21.937], [213.047, 12.279], [202.042, 23.284], [-200.848, 23.284], [-215.531, 37.968], [-215.531, 53.022], [-215.523, 53.022], [-4.546, 263.999], [204.654, 80.541], [235.885, 53.022], [261.812, 53.022], [274.74, 53.243], [310.255, 18.33], [309.397, -98.769], [304.049, -135.001], [247.115, -156.38], [214.756, -171.645], [-15.322, -246.781], [-249.45, -161.231], [-240.568, -102.055], [-200.072, -86.7], [-138.501, -102.037], [-76.923, -86.7], [-15.343, -102.037], [46.239, -86.7], [107.819, -102.037], [169.408, -86.7], [199.446, -93.992], [230.995, -74.441], [230.995, -67.327], [209.162, -45.494], [-239.807, -45.494], [-261.641, -23.66], [-239.807, -1.827], [188.473, -1.827], [210.306, 20.006], [210.306, 28.547], [189.156, 49.874], [-19.006, 76.488], [-45.628, 75.775], [-239.537, 49.912], [-261.64, 71.744], [-261.641, 99.577], [-237.47, 123.755], [203.893, 123.875], [225.244, 156.734], [-15.322, 248.487], [-246.818, 171.551], [-274.468, 158.086], [-285.792, 158.086], [-310.256, 133.622], [-310.256, -67.459], [-269.698, -108.017], [-249.061, -108.017], [-229.995, -113.047], [178.283, -126.694], [195.628, -74.352], [32.996, 242.5], [-35.516, 242.983], [-235.634, -133.728], [-215.663, -187.819], [216.955, -166.975], [236.871, -161.443], [269.174, -161.443], [296.853, -133.764], [296.853, -99.07], [269.174, -71.39], [254.526, -71.39], [188.703, -104.494], [183.934, -109.444], [141.116, -118.173], [108.923, -147.721], [65.512, -142.721], [25.744, -160.825], [-14.024, -142.721], [-57.435, -147.721], [-89.629, -118.173], [-133.069, -107.48], [-141.115, -103.886], [-267.73, 84.42], [-226.426, 125.724], [-185.121, 84.42], [24.902, -117.827], [251.855, 109.31], [251.855, 117.71], [208.587, 160.978], [-298.695, 160.978]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.317647069693, 0.549019634724, 0.560784339905, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 14,
            ix: 5
          },
          lc: 2,
          lj: 1,
          ml: 4,
          d: [{
            n: 'd',
            nm: 'dash',
            v: {
              a: 0,
              k: 20,
              ix: 1
            }
          }, {
            n: 'o',
            nm: 'offset',
            v: {
              a: 0,
              k: 0,
              ix: 7
            }
          }],
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [966.147, 540.147],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            n: ['0p34_1_0p167_0'],
            t: -1,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 29,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 89,
            s: [0],
            e: [2]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 119,
            s: [2],
            e: [2]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 179,
            s: [2],
            e: [11.9]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 209,
            s: [11.9],
            e: [11.9]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 269,
            s: [11.9],
            e: [10.1]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p833_1_0p66_0'],
            t: 299,
            s: [10.1],
            e: [10.1]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            n: ['0p833_1_0p167_0'],
            t: 359,
            s: [10.1],
            e: [27]
          }, {
            t: 369
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.663],
              y: [0.861]
            },
            o: {
              x: [0.331],
              y: [0]
            },
            n: ['0p663_0p861_0p331_0'],
            t: -1,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.362],
              y: [1]
            },
            o: {
              x: [0.164],
              y: [0.116]
            },
            n: ['0p362_1_0p164_0p116'],
            t: 0,
            s: [0],
            e: [16.9]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 29,
            s: [16.9],
            e: [16.9]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 89,
            s: [16.9],
            e: [35.9]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 119,
            s: [35.9],
            e: [35.9]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 179,
            s: [35.9],
            e: [30]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 209,
            s: [30],
            e: [30]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p833_1_0p66_0'],
            t: 269,
            s: [30],
            e: [30]
          }, {
            t: 359
          }],
          ix: 2
        },
        o: {
          a: 1,
          k: [{
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            n: ['0p34_1_0p167_0'],
            t: -1,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 29,
            s: [0],
            e: [0]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 89,
            s: [0],
            e: [74]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 119,
            s: [74],
            e: [74]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 179,
            s: [74],
            e: [175]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 209,
            s: [175],
            e: [175]
          }, {
            i: {
              x: [0.34],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p34_1_0p66_0'],
            t: 269,
            s: [175],
            e: [251]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.66],
              y: [0]
            },
            n: ['0p833_1_0p66_0'],
            t: 299,
            s: [251],
            e: [251]
          }, {
            t: 359
          }],
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }],
      ip: 1,
      op: 372,
      st: 30,
      bm: 0
    }]
  }],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 0,
    nm: 'Reset',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [500, 450, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [960, 540, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 1920,
    h: 1080,
    ip: 224,
    op: 242,
    st: -135,
    bm: 0
  }, {
    ddd: 0,
    ind: 2,
    ty: 0,
    nm: 'Taco-Pause',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [500, 450, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [960, 540, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 1920,
    h: 1080,
    ip: 198,
    op: 224,
    st: -101,
    bm: 0
  }, {
    ddd: 0,
    ind: 3,
    ty: 0,
    nm: 'Taco',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [500, 450, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [960, 540, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 1920,
    h: 1080,
    ip: 168,
    op: 198,
    st: -101,
    bm: 0
  }, {
    ddd: 0,
    ind: 4,
    ty: 0,
    nm: 'Pizza-Pause',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [500, 450, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [960, 540, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 1920,
    h: 1080,
    ip: 142,
    op: 168,
    st: -67,
    bm: 0
  }, {
    ddd: 0,
    ind: 5,
    ty: 0,
    nm: 'Pizza',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [500, 450, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [960, 540, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 1920,
    h: 1080,
    ip: 112,
    op: 142,
    st: -67,
    bm: 0
  }, {
    ddd: 0,
    ind: 6,
    ty: 0,
    nm: 'Buger-Pause',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [500, 450, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [960, 540, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 1920,
    h: 1080,
    ip: 93,
    op: 112,
    st: -26,
    bm: 0
  }, {
    ddd: 0,
    ind: 7,
    ty: 0,
    nm: 'Burger',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [500, 450, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [960, 540, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 1920,
    h: 1080,
    ip: 56,
    op: 93,
    st: -26,
    bm: 0
  }, {
    ddd: 0,
    ind: 8,
    ty: 0,
    nm: 'Salad-Pause',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [500, 450, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [960, 540, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 1920,
    h: 1080,
    ip: 31,
    op: 56,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 9,
    ty: 0,
    nm: 'Salad-Animate',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [500, 450, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [960, 540, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 1920,
    h: 1080,
    ip: 0,
    op: 31,
    st: 0,
    bm: 0
  }],
  markers: []
};

export { foodLoopAnimationData as default };
